import { useCallback, useSyncExternalStore } from "react";

function subscribeToThemeChanges(onChange: () => void) {
  // Listen for theme changes on the root element
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["class", "data-theme"],
  });

  return () => observer.disconnect();
}

export const useCSSVariable = (variableName: string) => {
  const getSnapshot = useCallback(
    () => getComputedStyle(document.documentElement).getPropertyValue(variableName).trim(),
    [variableName],
  );

  return useSyncExternalStore(subscribeToThemeChanges, getSnapshot, () => "");
};
